import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';

import { ApiClientService } from '../../api-client.service';
import { AppConst } from '../../app-const';
import { SpinnerService } from '../../services/spinner.service';
import { ApiUser, ApiSetUsersRequest } from '../../api-client-module';
import { SessionService } from '../../session.service';
import { SelectExhibits } from '../../firestore-models/user';
import { Project } from '../../firestore-models/project';
import { Exhibit } from '../../firestore-models/exhibit';
import { TranslateService } from '@ngx-translate/core';

export interface UserDialogData {
  change_type: number;
  user?: ApiUser;
  login_user_project_ids: Array<any>;
}

export interface ExhibitObj {
  [prop: string]: Array<Exhibit>
}

export interface Obj {
  [prop: string]: any       // これを記述することで、どんなプロパティでも持てるようになる
}

@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.css'],
  standalone: false,
})
export class UserDialogComponent implements OnInit {

  readonly userTypes = AppConst.USER_TYPES;
  readonly userTypeAdmin = AppConst.MANAGE_USER_TYPE_ADMIN;
  readonly userTypeUser = AppConst.MANAGE_USER_TYPE_USER;
  user?: ApiUser;
  loginUserProjectIds!: Array<any>;

  isAdded: boolean = false;

  loginUserType!: number;

  userFormGroup!: FormGroup;
  userIdControl!: FormControl;
  userNameControl!: FormControl;
  userTypeControl!: FormControl;
  userDescControl!: FormControl;
  isEditControl!: FormControl;

  private projectsCollection!: AngularFirestoreCollection<Project>;
  projectsObservable!: Observable<Project[]>;
  projectSubscribe!: Subscription;
  projects: Array<Project> = [];
  selection = new SelectionModel<Project>(true, []);
  private exhibitsCollection!: AngularFirestoreCollection<Exhibit>;
  exhibitsObservable!: Observable<Exhibit[]>;
  exhibitSubscribe!: Subscription;
  exhibits: Array<Exhibit> = [];
  exhibitSelection = new SelectionModel<Exhibit>(true, []);
  exhibitSelections: Obj;
  projectExhibits: ExhibitObj;
  selectExhibits: Array<SelectExhibits> = [];

  masterAvailableProjects: Array<any> = [];
  userAvailableProjects: Array<any> = [];
  readonly USER_TYPE_ADMIN: number = AppConst.MANAGE_USER_TYPE_ADMIN;
  readonly USER_TYPE_MASTER: number = AppConst.MANAGE_USER_TYPE_MASTER;
  readonly USER_TYPE_USER: number = AppConst.MANAGE_USER_TYPE_USER;

  currentLang: string = 'ja';

  constructor(
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<UserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserDialogData,
    private formBuilder: FormBuilder,
    private angularFirestore: AngularFirestore,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) {
    if (this.sessionService.session.isLogin) {
      this.loginUserType = this.sessionService.session.user!.user_type;
    }
    this.exhibitSelections = {};
    this.projectExhibits = {};
  }

  ngOnInit(): void {
    this.user = this.data.user;
    if (!this.user) {
      this.user = {
        user_id: '',
        user_name: '',
        user_desc: '',
        user_type: 1,
        is_edit: true,
        project_ids: [],
        exhibit_ids: []
      };
      this.isAdded = true;
    }
    this.exhibitsCollection = this.angularFirestore.collection<Exhibit>(
      AppConst.FIRESTORE_EXHIBITS, ref => ref.orderBy('project_id', 'asc').orderBy('exhibit_id', 'asc'));
    this.exhibitsObservable = this.exhibitsCollection.valueChanges({ idField: 'id' });
    this.exhibitSubscribe = this.exhibitsObservable.subscribe(exhibits => {
      this.exhibits = exhibits;
      this.projectsCollection = this.angularFirestore.collection<Project>(AppConst.FIRESTORE_PROJECTS);
      this.projectsObservable = this.projectsCollection.valueChanges({ idField: 'id' });
      this.projectSubscribe = this.projectsObservable.subscribe(projects => {
        // ログインユーザーが参照できるプロジェクトIDを取得
        this.loginUserProjectIds = this.data.login_user_project_ids;
        if (!this.loginUserProjectIds) {
          // 未セット（アドミンユーザーの場合）はここでセット
          this.loginUserProjectIds = [];
          for (const project of projects) {
            this.loginUserProjectIds.push(project.project_id);
          }
        }
        this.userAvailableProjects = [];
        this.masterAvailableProjects = [];
        for (const project of projects) {
          for (const loginUserProjectId of this.loginUserProjectIds) {
            if (project.project_id == loginUserProjectId) {
              for (const exhibit of exhibits) {
                if (exhibit.project_id === loginUserProjectId) {
                  // 一般ユーザーのプロジェクトリスト
                  // （※展示物登録のあるプロジェクトのみ）
                  this.userAvailableProjects.push(project);
                  break;
                }
              }
              // プロジェクト管理者のプロジェクトリスト
              this.masterAvailableProjects.push(project);
            }
          }
        }
        if (this.user?.user_type === AppConst.MANAGE_USER_TYPE_USER) {
          // this.projects = this.userAvailableProjects;
          this.projects = this.masterAvailableProjects;
        } else {
          this.projects = this.masterAvailableProjects;
        }
        // 選択可能な展示IDリストを作成
        for (const project of this.userAvailableProjects) {
          var projectExhibits = [];
          for (const exhibit of exhibits) {
            if (project.project_id === exhibit.project_id) {
              projectExhibits.push(exhibit);
            }
          }
          this.projectExhibits[project.project_id] = projectExhibits;
        }
        // 登録済みのプロジェクトにチェックを入れる
        this.selection = new SelectionModel<Project>(true, []);
        if (this.user?.user_type !== AppConst.MANAGE_USER_TYPE_ADMIN) {
          for (const projectId of this.user!.project_ids!) {
            for (const project of this.projects) {
              if (projectId === project.project_id) {
                this.selection.toggle(project);
                break;
              }
            }
          }
        // } else if (this.user?.user_type === AppConst.MANAGE_USER_TYPE_USER) {
        //   for (const project of projects) {
        //     if (this.loginUserType === AppConst.MANAGE_USER_TYPE_MASTER) {
        //       for (const loginUserProjectId of this.loginUserProjectIds) {
        //         if (project.project_id == loginUserProjectId) {
        //           this.selection.toggle(project);
        //         }
        //       }
        //     }
        //   }
        }
        // 登録済みの展示物にチェックを入れる
        var projectExhibits = [];
        for (const project of this.userAvailableProjects) {
          let exhibitSelection = new SelectionModel<Exhibit>(true, []);
          if (this.user!.exhibit_ids && this.user!.exhibit_ids.length > 0) {
            for (const exhibit_ids of this.user!.exhibit_ids!) {
              if (project.project_id === exhibit_ids.project_id) {
                for (const exhibit_id of exhibit_ids.exhibit_ids) {
                  for (const exhibit of exhibits) {
                    if (project.project_id === exhibit.project_id && exhibit.id === exhibit_id) {
                      exhibitSelection.toggle(exhibit);
                      break;
                    }
                  }
                }
              }
            }
          }
          this.exhibitSelections[project.project_id] = exhibitSelection;
        }
      });
    })

    this.createForm();
    this.userIdControl = this.userFormGroup.get('userId') as FormControl;
    this.userNameControl = this.userFormGroup.get('userName') as FormControl;
    this.userTypeControl = this.userFormGroup.get('userType') as FormControl;
    this.userDescControl = this.userFormGroup.get('userDesc') as FormControl;
    this.isEditControl = this.userFormGroup.get('isEdit') as FormControl;
  }

  ngOnDestroy(): void {
    this.exhibitSubscribe.unsubscribe();
    this.projectSubscribe.unsubscribe();
  }

  public getErrorMessageToUserId() {
    return this.userIdControl.hasError('required')
      ? this.translate.instant('必須項目')
    : this.userIdControl.hasError('email')
          ? this.translate.instant('メールアドレス')
          : '';
  }

  public getErrorMessageToUserName() {
    return this.userNameControl.hasError('required')
      ? this.translate.instant('必須項目')
    : '';
  }

  public getErrorMessageToUserType() {
    return this.userTypeControl.hasError('required')
      ? this.translate.instant('必須項目')
    : '';
  }

  public getErrorMessageToUserDesc() {
    return this.userDescControl.hasError('required')
      ? this.translate.instant('必須項目')
    : '';
  }

  private createForm() {
    this.userFormGroup = this.formBuilder.group(
      {
        userId: [this.user!.user_id, [Validators.required, Validators.email]],
        userName: [this.user!.user_name, [Validators.required]],
        userType: [this.user!.user_type, [Validators.required]],
        isEdit: [this.user!.is_edit, []],
        userDesc: [this.user!.user_desc, [Validators.required]],
      }
    );
  }

  public selectUserType(event: any) {
    if (event.value === AppConst.MANAGE_USER_TYPE_USER) {
      this.projects = this.userAvailableProjects;
    } else {
      this.projects = this.masterAvailableProjects;
    }
  }

  addUser(): void {
    if (this.userFormGroup.valid) {
      var is_edit = false;
      if (this.user!.user_type==this.USER_TYPE_ADMIN || this.user!.user_type==this.USER_TYPE_MASTER) {
        is_edit = true;
      } else if (this.user!.user_type==this.USER_TYPE_USER) {
        is_edit = this.isEditControl.value;
      }
      this.user!.user_id = this.userIdControl.value;
      this.user!.user_name = this.userNameControl.value;
      this.user!.user_type = this.userTypeControl.value;
      this.user!.is_edit = is_edit;
      this.user!.user_desc = this.userDescControl.value;
      let projectIds: Array<string> = [];
      if (this.user!.user_type !== this.userTypeAdmin) {
        for (const project of this.projects) {
          if (this.selection.isSelected(project)) {
            projectIds.push(project.project_id);
            if (this.user!.user_type === AppConst.MANAGE_USER_TYPE_USER) {
              if (this.projectExhibits[project.project_id]) {
                let exhibitIds: Array<string> = [];
                for (const projectExhibit of this.projectExhibits[project.project_id]) {
                  const exhibitSelection = this.exhibitSelections[project.project_id];
                  if (exhibitSelection.isSelected(projectExhibit)) {
                    for (const exhibit of this.exhibits) {
                      if (project.project_id === exhibit.project_id && projectExhibit.exhibit_id === exhibit.exhibit_id && exhibit.id) {
                        exhibitIds.push(exhibit.id);
                      }
                    }
                  }
                }
                this.selectExhibits.push({project_id:project.project_id, exhibit_ids:exhibitIds});
              } else {
                this.selectExhibits.push({project_id:project.project_id, exhibit_ids:[]});
              }
            }
          }
        }
      }
      // ログインユーザー以外のプロジェクトID＆展示IDが登録されている場合はセット
      if (this.user!.project_ids && this.user!.project_ids.length > 0) {
        for (const project_id of this.user!.project_ids) {
          // プロジェクトID
          if (!this.loginUserProjectIds.includes(project_id)) {
            projectIds.push(project_id);
            if (this.user!.exhibit_ids && this.user!.exhibit_ids.length > 0) {
              // 展示ID
              for (const exhibit_ids of this.user!.exhibit_ids) {
                if (exhibit_ids.project_id === project_id) {
                  this.selectExhibits.push(exhibit_ids);
                }
              }
            }
          }
        }
      }
      this.user!.project_ids = projectIds;
      this.user!.exhibit_ids = this.selectExhibits;
      if (this.user) {
        let request: ApiSetUsersRequest = {
          access_token: '',
          change_type: this.data.change_type,
          users: [this.user]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setUsers(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じメールアドレスが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.projects.length;
    return numSelected === numRows;
  }

  exhibitIsAllSelected(project: Project) {
    const numSelected = this.exhibitSelections[project.project_id].selected.length;
    const numRows = this.projectExhibits[project.project_id].length;
    return numSelected === numRows;
  }

  exhibitIsSelected(project_id: string) {
    if (this.exhibitSelections[project_id].selected.length < 1) {
      return false;
    };
    return true;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.projects.forEach(row => this.selection.select(row));
  }

  exhibitMasterToggle(project: Project) {
    const exhibits: Array<Exhibit> = this.projectExhibits[project.project_id];
    this.exhibitIsAllSelected(project) ?
    this.exhibitSelections[project.project_id].clear() :
    exhibits.forEach(row => this.exhibitSelections[project.project_id].select(row));
  }

  checkboxLabel(row?: Project): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'}`;
  }

  exhibitCheckboxLabel(project: Project, row?: Exhibit): string {
    if (!row) {
      const state = `${this.exhibitIsAllSelected(project) ? 'select' : 'deselect'} all`;
      // if (this.exhibitIsSelected(project.project_id)) {
      //   if (!this.selection.isSelected(project)) {
      //     this.selection.toggle(project);
      //   }
      // } else {
      //   if (this.selection.isSelected(project)) {
      //     this.selection.deselect(project);
      //   }
      // }
      return state;
    }
    return `${this.exhibitSelections[project.project_id].isSelected(row) ? 'deselect' : 'select'}`;
  }

  checkExhibit(project: Project, exhibit: Exhibit | null) {
    if (exhibit) {
      if (this.exhibitSelections[project.project_id].isSelected(exhibit)) {
        if (!this.selection.isSelected(project)) {
          this.selection.toggle(project);
        }
      } else {
        if (!this.exhibitIsSelected(project.project_id)) {
          if (this.selection.isSelected(project)) {
            this.selection.deselect(project);
          }
        }
      }
    } else {
      const numSelected = this.exhibitSelections[project.project_id].selected.length;
      if (numSelected > 0) {
        if (!this.selection.isSelected(project)) {
          this.selection.toggle(project);
        }
      } else {
        if (this.selection.isSelected(project)) {
          this.selection.toggle(project);
        }
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
